<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">编辑vip设置</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="viplist.length > 1 ? viplist.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回设置管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsVip'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in viplist" :key="index">
            <div class="TTL-form-submit-box-title">设置-{{index+1}}</div>
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <label class="TTL-form-label">vip名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入vip名称',type:'input',clearable:true,ischange:true,width:'250px'}" 
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.name=val.value;
                                
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">设置原始金额<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入原始金额',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.baseprice"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.baseprice=val.value;
                            }
                            if(val.type=='change') {
                                item.baseprice=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">设置支付金额<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入支付金额',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.price"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.price=val.value;
                                
                            }
                            if(val.type=='change') {
                                item.price=val.value;
                                
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">有效时间<i>*</i></label>
                    <wcinputprex 
                        :value="item.nums" 
                        :option="{placeholder:'有效时间',childtype:'select',width:'200px',isinput:true}"
                        :svalue="item.type"
                        :slist="timetype"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.nums=val.value;
                                
                            }
                            if(val.type=='change') {
                                item.type=val.value;
                                
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">推广标签</label>
                    <wcinput :option="{placeholder:'请输入显示标签',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.label"
                        @finish="(val)=> {
                            if(val.type=='input') {
                                item.label=val.value;
                            }
                            if(val.type=='change') {
                                item.label=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">活动时间<i>（在时间范围内，小程序显示的是支付金额，到期后支付金额将重置为原始金额）</i></label>
                    <wctime :option="{placeholder:'请选择活动时间',type:'datetimerange',format:'YYYY-MM-DD HH:mm',clearable:true,width:'400px',ischange:'true'}"
                        :value="item.activetime"
                        @finish="(val) => {
                            if(val.type=='change') {
                                item.activetime=val.value;
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">是否支持微信群发</label>
                    <el-switch v-model="item.isforward" />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">是否支持批量转发</label>
                    <el-switch v-model="item.ismoreshare" />
                </el-form-item>
            </el-form>
        </div>
    </div>
</div>
</template>

<script>
import INTERFACE_MODEL_VIP from '@/Interface/Es/vip';
export default {
    components:{},
    data() {
        return {
            Browser:'editvip',
            loadingobj:'editvip',
            limit:10,  //限制添加数据条数
            vipinfo:{id:'',name:'',type:1,nums:'',price:'',isforward:true,ismoreshare:true}, //设置模板信息           
            viplist:[], //续费设置
            timetype:[], //时间类型
            typelist:[
                {id:1,name:'充值条数'},
                {id:2,name:'充值可发布时间'}
            ],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetRenewTimeType(isfresh); //获取设置时间类型
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm(
                    '当前有操作正在执行，是否要将其覆盖 ？',
                    '删除提示',
                    {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
                ).then(()=> {
                    this.GetVipInfos(data.param.id);
                }).catch(()=> {

                });
            }else if(data.reload) {  //浏览器重新刷新时执行的操作

            }else {
                this.GetVipInfos(data.param.id);
            }
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.viplist.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个设置',type:'warning'});return false;}
            var data=[];
            for(var i in this.viplist) data.push(this.viplist[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_VIP.EDIT_VIP({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.$notice({title:'成功提示',message:'添加数据成功',type:'success'});
                this.$parent.JUMPVIEW({name:'EsVip',delname:'EsEditVip'})
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作

        /** 获取续费设置信息 **/
        GetVipInfos(ids) {
            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_VIP.GET_VIP_INFO({ids:ids}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.viplist=res.data;
                for(var i=0; i < this.viplist.length;i++) {
                    this.viplist[i].isforward=this.viplist[i].isforward==0? false : true;
                    this.viplist[i].ismoreshare=this.viplist[i].ismoreshare==0? false : true;
                }
            });
        },


        /** 获取会员类型信息 **/
        GetRenewTimeType(isfresh) {
            this.$method.GET_RENEW_TIME_TYPE(isfresh).then((res) => {this.timetype=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
</style>